<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import Pattern from './Pattern.vue';

const route = useRoute();

const state = computed(() => {
    if(route.name === 'start'){
        return 'hidden'
    }

    if(['categories', 'category'].includes(route.name)){
        return 'right'
    }

    return 'left';
})

const classes = computed(() => {
    if(state.value === 'hidden'){
        return 'opacity-0';
    }

    if(state.value === 'left'){
        return 'tilt-left';
    }

    if(state.value === 'right'){
        return 'tilt-right'
    }
})
</script>

<template>
    <div :class="classes" class="background fixed isolate -z-50 left-0 top-0 size-full overflow-hidden pointer-events-none">
        <div class="gradient-left absolute left-0 top-0 w-1/2 h-full bg-gradient-secondary"></div>
        <div class="gradient-right absolute right-0 top-0 w-1/2 h-full bg-gradient-secondary"></div>
        <Pattern class="pattern-right absolute z-10" orientation="right" />
        <Pattern class="pattern-left absolute z-10" orientation="left" />
    </div>
</template>